// extracted by mini-css-extract-plugin
module.exports = {"vGray14":"#7d85a4","vGray18":"#bcc0c9","tag":"Tag_tag__1jDVB","content":"Tag_content__23qMf","action":"Tag_action__1LkHi","cross":"Tag_cross__19rac close_close__167jw"};